var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _linearGradient37, _linearGradient38, _linearGradient39, _linearGradient40, _linearGradient41, _linearGradient42, _linearGradient43, _linearGradient44, _linearGradient45, _linearGradient46, _linearGradient47, _linearGradient48, _linearGradient49, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconWorkingAtHomeStorm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#537983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e5959"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg1",
    y1: 94,
    y2: 319.109
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eef5f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cbe5e8"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientTransform: "matrix(.707 .707 -.707 .707 396.111 553.701)",
    gradientUnits: "userSpaceOnUse",
    x1: -579.264,
    x2: -571.265,
    xlinkHref: "#lg2",
    y1: -70.64,
    y2: -70.64
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientTransform: "matrix(-.707 -.707 .707 -.707 -1663.419 629.63)",
    gradientUnits: "userSpaceOnUse",
    x1: -877.85,
    x2: -869.85,
    xlinkHref: "#lg2",
    y1: 1663.134,
    y2: 1663.134
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientTransform: "matrix(-.707 -.707 .707 -.707 -1663.419 629.63)",
    gradientUnits: "userSpaceOnUse",
    x1: -877.85,
    x2: -869.85,
    xlinkHref: "#lg2",
    y1: 1566.388,
    y2: 1566.388
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientTransform: "matrix(.707 .707 -.707 .707 396.111 553.701)",
    gradientUnits: "userSpaceOnUse",
    x1: -453.057,
    x2: -445.057,
    xlinkHref: "#lg2",
    y1: -22.085,
    y2: -22.085
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientTransform: "matrix(.707 .707 -.707 .707 396.111 553.701)",
    gradientUnits: "userSpaceOnUse",
    x1: -453.057,
    x2: -445.057,
    xlinkHref: "#lg2",
    y1: 73.16,
    y2: 73.16
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientTransform: "matrix(-.707 -.707 .707 -.707 -1663.419 629.63)",
    gradientUnits: "userSpaceOnUse",
    x1: -1004.058,
    x2: -996.058,
    xlinkHref: "#lg2",
    y1: 1448.087,
    y2: 1448.087
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientTransform: "matrix(-.707 -.707 .707 -.707 -1663.419 629.63)",
    gradientUnits: "userSpaceOnUse",
    x1: -1004.058,
    x2: -996.058,
    xlinkHref: "#lg2",
    y1: 1517.834,
    y2: 1517.834
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientTransform: "matrix(.707 .707 -.707 .707 396.111 553.701)",
    gradientUnits: "userSpaceOnUse",
    x1: -369.275,
    x2: -361.276,
    xlinkHref: "#lg2",
    y1: -329.056,
    y2: -329.056
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientTransform: "matrix(-.707 -.707 .707 -.707 -1663.419 629.63)",
    gradientUnits: "userSpaceOnUse",
    x1: -1087.839,
    x2: -1079.839,
    xlinkHref: "#lg2",
    y1: 1850.303,
    y2: 1850.303
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientTransform: "matrix(-.707 -.707 .707 -.707 -1663.419 629.63)",
    gradientUnits: "userSpaceOnUse",
    x1: -1176.335,
    x2: -1168.335,
    xlinkHref: "#lg2",
    y1: 1734.787,
    y2: 1734.787
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientTransform: "matrix(-.707 -.707 .707 -.707 -1663.419 629.63)",
    gradientUnits: "userSpaceOnUse",
    x1: -1176.335,
    x2: -1168.335,
    xlinkHref: "#lg2",
    y1: 1830.033,
    y2: 1830.033
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientTransform: "matrix(.707 .707 -.707 .707 396.111 553.701)",
    gradientUnits: "userSpaceOnUse",
    x1: -175.785,
    x2: -167.785,
    xlinkHref: "#lg2",
    y1: -237.132,
    y2: -237.132
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientTransform: "matrix(-.707 -.707 .707 -.707 -1663.419 629.63)",
    gradientUnits: "userSpaceOnUse",
    x1: -1281.33,
    x2: -1273.33,
    xlinkHref: "#lg2",
    y1: 1663.133,
    y2: 1663.133
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientTransform: "matrix(-.707 -.707 .707 -.707 -1663.419 629.63)",
    gradientUnits: "userSpaceOnUse",
    x1: -1281.33,
    x2: -1273.33,
    xlinkHref: "#lg2",
    y1: 1758.379,
    y2: 1758.379
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 433.028,
    x2: 314.534,
    y1: 208.302,
    y2: 208.302
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3e5959",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8153,
    stopColor: "#394c4c",
    stopOpacity: 0.815
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#384949"
  }))), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe9738"
  }))), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 425.189,
    x2: 461.85,
    xlinkHref: "#lg3",
    y1: 107.956,
    y2: 144.617
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 61.189,
    x2: 97.85,
    xlinkHref: "#lg3",
    y1: 177.956,
    y2: 214.617
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cbe5e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8ebac5"
  }))), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 407.737,
    x2: 475.615,
    xlinkHref: "#lg4",
    y1: 37.828,
    y2: 105.706
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 97.737,
    x2: 165.615,
    xlinkHref: "#lg4",
    y1: 83.828,
    y2: 151.706
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg2",
    y1: 189.154,
    y2: 234.773
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cbe5e8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ca1b1"
  }))), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 427,
    x2: 369.965,
    xlinkHref: "#lg5",
    y1: 208.302,
    y2: 208.302
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 80.382,
    x2: 419.347,
    xlinkHref: "#lg2",
    y1: 34.218,
    y2: 373.183
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientTransform: "matrix(-1 0 0 -1 3702 -649.53)",
    gradientUnits: "userSpaceOnUse",
    x1: 3282.1,
    x2: 3602.201,
    xlinkHref: "#lg2",
    y1: -1023.263,
    y2: -703.163
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 479.175,
    x2: 447.675,
    xlinkHref: "#lg5",
    y1: 367.312,
    y2: 389.812
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg6"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe99a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fd4755"
  }))), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg6",
    y1: 326.046,
    y2: 440.82
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 449.134,
    x2: 396.615,
    y1: 376.771,
    y2: 376.771
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fd4755",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c41926"
  }))), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 220.564,
    x2: 192.903,
    xlinkHref: "#lg6",
    y1: 277.481,
    y2: 321.739
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 292.34,
    x2: 315.978,
    xlinkHref: "#lg6",
    y1: 282.162,
    y2: 319.881
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 178.15,
    x2: 304.659,
    xlinkHref: "#lg3",
    y1: 83.35,
    y2: 209.859
  })), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg7"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdcbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa9b1"
  }))), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 131.427,
    x2: 161.356,
    xlinkHref: "#lg7",
    y1: 153.786,
    y2: 183.716
  })), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 340.712,
    x2: 382.594,
    xlinkHref: "#lg7",
    y1: 148.101,
    y2: 189.983
  })), _linearGradient40 || (_linearGradient40 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 147.363,
    x2: 362.638,
    xlinkHref: "#lg7",
    y1: 171.714,
    y2: 171.714
  })), _linearGradient41 || (_linearGradient41 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 200.335,
    x2: 326.844,
    xlinkHref: "#lg3",
    y1: 61.165,
    y2: 187.674
  })), _linearGradient42 || (_linearGradient42 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    y1: 176,
    y2: 228
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa9b1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9972,
    stopColor: "#ffa78f"
  }))), _linearGradient43 || (_linearGradient43 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 256.069,
    x2: 256.069,
    y1: 533.703,
    y2: 472.368
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#883f2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d3326"
  }))), _linearGradient44 || (_linearGradient44 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    y1: 454.343,
    y2: 479.299
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ca6e59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#883f2e"
  }))), _linearGradient45 || (_linearGradient45 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 222.445,
    x2: 298.315,
    xlinkHref: "#lg2",
    y1: 275.785,
    y2: 444.543
  })), _linearGradient46 || (_linearGradient46 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 285.36,
    x2: 241.298,
    y1: 380.06,
    y2: 335.998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eef5f6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _linearGradient47 || (_linearGradient47 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg5",
    y1: 413.113,
    y2: 449.505
  })), _linearGradient48 || (_linearGradient48 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 191.643,
    x2: 222.928,
    xlinkHref: "#lg1",
    y1: 173.382,
    y2: 173.382
  })), _linearGradient49 || (_linearGradient49 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 287.072,
    x2: 318.357,
    xlinkHref: "#lg1",
    y1: 173.382,
    y2: 173.382
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m473.707 4.6h-437.414c-18.006 0-32.602 14.596-32.602 32.601v343.278c0 17.996 14.596 32.591 32.601 32.591h437.415c18.006 0 32.601-14.596 32.601-32.591v-343.278c.001-18.005-14.595-32.601-32.601-32.601z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m20.727 119.538c-1.024 0-2.047-.391-2.829-1.172-1.562-1.562-1.562-4.095 0-5.656l37.122-37.121c1.563-1.563 4.095-1.563 5.657 0 1.562 1.562 1.562 4.095 0 5.656l-37.121 37.121c-.782.781-1.805 1.172-2.829 1.172z",
    fill: "url(#SVGID_2_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m111.939 94.083c-1.024 0-2.047-.391-2.829-1.172-1.562-1.562-1.562-4.095 0-5.656l37.122-37.121c1.563-1.562 4.096-1.562 5.657 0 1.562 1.562 1.562 4.095 0 5.656l-37.122 37.121c-.781.781-1.805 1.172-2.828 1.172z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.484 154.538c-1.024 0-2.047-.391-2.829-1.172-1.562-1.562-1.562-4.095 0-5.656l21.212-21.213c1.563-1.563 4.095-1.563 5.657 0 1.562 1.562 1.562 4.095 0 5.656l-21.212 21.213c-.78.781-1.804 1.172-2.828 1.172z",
    fill: "url(#SVGID_4_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m75.636 243.113c-1.024 0-2.047-.391-2.829-1.172-1.562-1.562-1.562-4.095 0-5.656l37.121-37.121c1.563-1.563 4.095-1.563 5.657 0 1.562 1.562 1.562 4.095 0 5.656l-37.121 37.121c-.78.782-1.804 1.172-2.828 1.172z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.242 302.508c-1.024 0-2.047-.391-2.829-1.172-1.562-1.562-1.562-4.095 0-5.656l21.212-21.212c1.563-1.563 4.095-1.563 5.657 0 1.562 1.562 1.562 4.095 0 5.656l-21.212 21.212c-.78.781-1.804 1.172-2.828 1.172z",
    fill: "url(#SVGID_6_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m49.121 335.387c-1.024 0-2.047-.391-2.829-1.172-1.562-1.562-1.562-4.095 0-5.656l37.121-37.121c1.563-1.563 4.095-1.563 5.657 0 1.562 1.562 1.562 4.095 0 5.656l-37.12 37.121c-.782.781-1.805 1.172-2.829 1.172z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m106.394 278.113c-1.024 0-2.047-.391-2.829-1.172-1.562-1.562-1.562-4.095 0-5.656l21.212-21.212c1.563-1.563 4.096-1.562 5.657 0 1.562 1.562 1.562 4.095 0 5.656l-21.212 21.212c-.781.782-1.805 1.172-2.828 1.172z",
    fill: "url(#SVGID_8_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m351.939 85.295c-1.024 0-2.047-.391-2.829-1.172-1.562-1.562-1.562-4.095 0-5.656l37.121-37.121c1.563-1.563 4.095-1.563 5.657 0 1.562 1.562 1.562 4.095 0 5.656l-37.121 37.121c-.78.781-1.804 1.172-2.828 1.172z",
    fill: "url(#SVGID_9_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m400.727 102.265c-1.024 0-2.047-.391-2.829-1.172-1.562-1.562-1.562-4.095 0-5.656l21.212-21.212c1.563-1.562 4.095-1.562 5.657 0s1.562 4.095 0 5.656l-21.212 21.212c-.781.781-1.805 1.172-2.828 1.172z",
    fill: "url(#SVGID_10_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m373.667 254.478c-1.024 0-2.047-.391-2.829-1.172-1.562-1.562-1.562-4.095 0-5.656l37.122-37.121c1.563-1.563 4.096-1.562 5.657 0 1.562 1.562 1.562 4.095 0 5.656l-37.122 37.121c-.781.781-1.805 1.172-2.828 1.172z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m448.97 179.174c-1.024 0-2.047-.391-2.829-1.172-1.562-1.562-1.562-4.095 0-5.656l21.212-21.212c1.563-1.563 4.096-1.562 5.657 0 1.562 1.562 1.562 4.095 0 5.656l-21.212 21.212c-.781.781-1.805 1.172-2.828 1.172z",
    fill: "url(#SVGID_12_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m423.758 287.113c-1.024 0-2.047-.391-2.829-1.172-1.562-1.562-1.562-4.095 0-5.656l37.121-37.121c1.563-1.563 4.095-1.563 5.657 0 1.562 1.562 1.562 4.095 0 5.656l-37.121 37.121c-.781.782-1.804 1.172-2.828 1.172z",
    fill: "url(#SVGID_13_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m397.243 379.387c-1.024 0-2.047-.391-2.829-1.172-1.562-1.562-1.562-4.095 0-5.656l37.121-37.121c1.563-1.563 4.095-1.563 5.657 0 1.562 1.562 1.562 4.095 0 5.656l-37.121 37.121c-.781.781-1.804 1.172-2.828 1.172z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m472.545 304.083c-1.024 0-2.047-.391-2.829-1.172-1.562-1.562-1.562-4.095 0-5.656l21.212-21.212c1.563-1.563 4.095-1.562 5.657 0s1.562 4.095 0 5.656l-21.212 21.212c-.78.781-1.804 1.172-2.828 1.172z",
    fill: "url(#SVGID_15_)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m494.354 4.067h-160.399c-6.603 0-11.955 14.595-11.955 32.601v343.278c0 17.996 5.352 32.591 11.955 32.591h160.399c6.603 0 11.955-14.596 11.955-32.591v-343.278c0-18.006-5.353-32.601-11.955-32.601z",
    fill: "url(#SVGID_16_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m456.084 74.5-46.409 46.409c-5.08 5.08-1.482 13.766 5.702 13.766h1.705c6.077 0 9.121 7.348 4.823 11.645l-28.544 28.544c-2.539 2.539.673 6.601 3.729 4.716l68.091-42.014c6.915-4.267 3.892-14.926-4.234-14.926-6.171 0-9.17-7.542-4.685-11.78l38.488-36.36z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m92.084 144.5-46.409 46.409c-5.08 5.08-1.482 13.766 5.702 13.766h1.705c6.077 0 9.121 7.348 4.823 11.645l-28.544 28.544c-2.539 2.539.673 6.601 3.729 4.716l68.091-42.014c6.915-4.267 3.892-14.926-4.234-14.926-6.171 0-9.17-7.542-4.685-11.78l38.487-36.36z",
    fill: "url(#SVGID_18_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m471.743 36.708c-3.751 0-7.361.599-10.743 1.703-3.618-11.803-14.6-20.386-27.589-20.386-15.934 0-28.852 12.917-28.852 28.852 0 2.302.271 4.541.781 6.688-13.599.959-24.333 12.293-24.333 26.135 0 14.471 11.731 26.202 26.202 26.202h64.534c19.108 0 34.597-15.49 34.597-34.597s-15.49-34.597-34.597-34.597z",
    fill: "url(#SVGID_19_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m161.743 82.708c-3.751 0-7.361.599-10.743 1.703-3.618-11.803-14.6-20.386-27.589-20.386-15.934 0-28.852 12.917-28.852 28.852 0 2.302.271 4.541.781 6.688-13.599.959-24.333 12.293-24.333 26.135 0 14.471 11.731 26.202 26.202 26.202h64.534c19.108 0 34.597-15.49 34.597-34.597s-15.49-34.597-34.597-34.597z",
    fill: "url(#SVGID_20_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.262 184.086h475.476v49.498h-475.476z",
    fill: "url(#SVGID_21_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m340.745 183.553h151.993v49.498h-151.993z",
    fill: "url(#SVGID_22_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m476.92 1.6h-443.84c-18.27 0-33.08 14.81-33.08 33.08v348.32c0 18.26 14.81 33.07 33.08 33.07h443.84c18.27 0 33.08-14.81 33.08-33.07v-348.32c0-18.27-14.81-33.08-33.08-33.08zm.46 350.52c0 15.51-12.58 28.09-28.09 28.09h-388.58c-15.51 0-28.09-12.58-28.09-28.09v-286.57c0-15.51 12.58-28.08 28.09-28.08h388.58c15.51 0 28.09 12.57 28.09 28.08z",
    fill: "url(#SVGID_23_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.48 401.61h425.04c17.22 0 31.19-13.97 31.19-31.19v-323.17c0-17.23-13.97-31.19-31.19-31.19h-425.04c-17.22 0-31.19 13.96-31.19 31.19v323.17c0 17.22 13.97 31.19 31.19 31.19zm-9.86-336.06c0-15.51 12.58-28.09 28.09-28.09h388.58c15.51 0 28.09 12.58 28.09 28.09v286.57c0 15.51-12.58 28.08-28.09 28.08h-388.58c-15.51 0-28.09-12.57-28.09-28.08z",
    fill: "url(#SVGID_24_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m477.38 324.067v27.52c0 15.51-12.58 28.09-28.09 28.09h-63.29v35.86h90.92c18.27 0 33.08-14.81 33.08-33.07v-58.4z",
    fill: "url(#SVGID_25_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m454.462 448.416h-398.924v-15.826c0-84.43 68.444-152.873 152.873-152.873h93.176c84.43 0 152.873 68.444 152.873 152.873v15.826z",
    fill: "url(#SVGID_26_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m386 305.127v143.289h68.462v-15.826c0-53.223-27.205-100.086-68.462-127.463z",
    fill: "url(#SVGID_27_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m179.057 271.342s-22.129 11.064-15.088 20.117c5.179 6.659 31.581 32.363 45.183 45.494 4.51 4.353 11.665 4.279 16.097-.153l29.751-29.75z",
    fill: "url(#SVGID_28_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m330.943 271.342s22.129 11.064 15.088 20.117c-5.179 6.659-31.581 32.363-45.183 45.494-4.51 4.353-11.665 4.279-16.097-.153l-29.751-29.75z",
    fill: "url(#SVGID_29_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m318.555 266.023h-126.949c-35.367 0-64.037-28.67-64.037-64.037v-57.118c0-70.423 57.089-127.511 127.511-127.511 70.423 0 127.511 57.089 127.511 127.511v57.118c.001 35.367-28.669 64.037-64.036 64.037z",
    fill: "url(#SVGID_30_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m120.477 169.875c0-17.598 12.215-32.342 28.63-36.217 4.388-1.036 8.582 2.357 8.582 6.865v58.703c0 4.508-4.194 7.901-8.582 6.865-16.415-3.874-28.63-18.619-28.63-36.216z",
    fill: "url(#SVGID_31_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m389.523 169.875c0-17.598-12.215-32.342-28.63-36.217-4.388-1.036-8.582 2.357-8.582 6.865v58.703c0 4.508 4.194 7.901 8.582 6.865 16.415-3.874 28.63-18.619 28.63-36.216z",
    fill: "url(#SVGID_32_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m255 306.951c-59.447 0-107.638-48.191-107.638-107.637v-55.199c0-59.447 48.191-107.637 107.637-107.637 59.447 0 107.637 48.191 107.637 107.637v55.199c.002 59.446-48.189 107.637-107.636 107.637z",
    fill: "url(#SVGID_33_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m372.904 138.275c-4.419.396-9.801.77-15.626 1.123-23.856 1.444-44.012-17.495-44.012-41.396-26.6 29.386-64.796 45.507-104.411 44.212-26.237-.858-52.05-2.202-71.611-3.971 1.848-52.231 37.699-95.794 86.074-109.305 10.102-2.836 20.746-4.334 31.772-4.334s21.67 1.498 31.772 4.334c19.79 5.513 37.508 16.093 51.625 30.211 20.396 20.426 33.334 48.247 34.417 79.126z",
    fill: "url(#SVGID_34_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m260.946 226.386h-11.893c-9.911 0-17.415-8.956-15.679-18.714l6.817-38.324h29.616l6.817 38.324c1.737 9.758-5.767 18.714-15.678 18.714z",
    fill: "url(#SVGID_35_)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m461.522 508.4h-410.906c-5.806 0-10.513-4.707-10.513-10.513v-25.481h431.932v25.481c0 5.806-4.707 10.513-10.513 10.513z",
    fill: "url(#SVGID_36_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m486.154 478.884h-462.308c-2.972 0-5.381-2.409-5.381-5.381v-19.708c0-2.972 2.409-5.381 5.381-5.381h462.308c2.972 0 5.381 2.409 5.381 5.381v19.708c0 2.972-2.409 5.381-5.381 5.381z",
    fill: "url(#SVGID_37_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m393.527 250.983h-277.054c-6.069 0-10.988 4.92-10.988 10.988v171.626c0 8.184 6.634 14.818 14.818 14.818h269.394c8.184 0 14.818-6.634 14.818-14.818v-171.625c0-6.069-4.919-10.989-10.988-10.989z",
    fill: "url(#SVGID_38_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 349.7,
    fill: "url(#SVGID_39_)",
    r: 26.436
  }), /*#__PURE__*/React.createElement("path", {
    d: "m105.485 386.333v47.264c0 8.184 6.634 14.818 14.818 14.818h269.394c8.184 0 14.818-6.634 14.818-14.818v-47.264z",
    fill: "url(#SVGID_40_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m207.285 193.035c-8.639 0-15.643-7.003-15.643-15.643v-8.022c0-8.639 7.003-15.643 15.643-15.643 8.639 0 15.643 7.003 15.643 15.643v8.022c0 8.64-7.004 15.643-15.643 15.643z",
    fill: "url(#SVGID_41_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m302.715 193.035c-8.639 0-15.643-7.003-15.643-15.643v-8.022c0-8.639 7.003-15.643 15.643-15.643 8.639 0 15.643 7.003 15.643 15.643v8.022c-.001 8.64-7.004 15.643-15.643 15.643z",
    fill: "url(#SVGID_42_)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWorkingAtHomeStorm);
export default __webpack_public_path__ + "static/media/icon-working-at-home-storm.c01416120e2eea53278fbaf89c45d374.svg";
export { ForwardRef as ReactComponent };